import Axios from "lib/Axios";

export const viewAllApplication = ({ body_data, params }) =>
  Axios.post(
    `https://leads.applykings.com/api/application-data?${params}`,
    body_data
  ).then((res) => res.data);
